import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { UsersService } from '..'
import { useInvitesStatuses } from './useInvitesStatuses'

const INVITE_DETAILS_QUERY_KEY = 'invite-details'

type Props = {
  id: string
  enabled?: boolean
}

export const useInviteDetails = ({ id, enabled = true }: Props) => {
  const { data: invite, ...rest } = useQuery({
    queryKey: [INVITE_DETAILS_QUERY_KEY, id],
    queryFn: () => UsersService.getInviteById(id),
    enabled
  })

  const { data: statuses } = useInvitesStatuses()

  // добавляем детали для отображения статуса
  const normalizedInvite = useMemo(() => {
    if (!invite) {
      return undefined
    }

    const currentStatus = statuses?.find(
      status => status.alias === invite.inviteStatus
    )

    return {
      ...invite,
      statusColor: currentStatus?.color || '',
      statusName: currentStatus?.name || '',
      statusIconUrl: currentStatus?.iconUrl || ''
    }
  }, [invite, statuses])

  return {
    ...rest,
    data: normalizedInvite
  }
}
